/* template */
<template><mpx-scroll-view :scroll-y="(true)" :class="({    'at-didao': atDidao,    'is-android': isAndroid,    'is-miniprogram': isMiniProgram,    'is-passenger': isPassenger  })" :scroll-into-view="(toView)" @scroll="scroll" class="didi-mall-city-list"><div v-for="(item, index) in (cityList)" :key="item.index" class="didi-mall-city-list-block"><div :id="(item.id === '*' ? 'star': item.id)" :data-letter-index="(index)" class="didi-mall-city-list-block_name">{{item.letter}}</div><div class="didi-mall-city-list-block_list"><mpx-view v-for="(city, index) in (item.cities)" :key="city['{{item.name}}']" @tap="selectCity(city)" class="city-item">{{city.name}}</mpx-view></div></div></mpx-scroll-view></template>

/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"m7dbcda14"}'>
.didi-mall-city-list
  .mpx-scroll-view-content
    width 100%
</style>
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m7dbcda14"}'>
.didi-mall-city-list
  z-index 0
  width: 100%
  height 85%
  &.at-didao
    height calc(100vh - 300rpx - constant(safe-area-inset-bottom))
    height calc(100vh - 300rpx - env(safe-area-inset-bottom))
  &.is-miniprogram
    height calc(100vh - 300rpx - constant(safe-area-inset-bottom))
    height calc(100vh - 300rpx - env(safe-area-inset-bottom))
  &.is-passenger
    height calc(100vh - 500rpx - constant(safe-area-inset-bottom))
    height calc(100vh - 500rpx - env(safe-area-inset-bottom))
  &.is-android
    &.is-passenger
      height calc(100vh - 500rpx - env(safe-area-inset-bottom))
    &.is-miniprogram
      height calc(100vh - 400rpx - env(safe-area-inset-bottom))

  .didi-mall-city-list-block
    margin-bottom 42rpx
    .didi-mall-city-list-block_name
      font-size 36rpx
      font-weight 600
      height 88rpx
      line-height 88rpx
      padding-left 32rpx
    .didi-mall-city-list-block_list
      .city-item
        width 84%
        margin-left 40rpx
        font-size 28rpx
        height 80rpx
        line-height 80rpx
        border-bottom 1px solid #e8e9e8
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import mpx, { createComponent } from '@mpxjs/core'
import { throttle } from '../../../lib/js/util'
import { is } from '@didi/webx-js'
let baseTop = 0
const windowHeight = mpx.getSystemInfoSync().windowHeight
createComponent({
  watch: {
    cityList(val) {
      val.length && setTimeout(() => {
        mpx.createSelectorQuery().in(this).selectAll('.didi-mall-city-list-block').boundingClientRect(res => {
          baseTop = res[0].top
        }).exec()
      }, 0)
    },
    toView() {
      this.intoView = true
      setTimeout(() => {
        this.intoView = false
      }, 200)
    },
  },
  properties: {
    cityList: Array,
    toView: String,
    atDidao: Boolean,
    isNewVersion: {
      type: Boolean,
      value: false,
    },
  },
  data: {
    intoView: false,
    isAndroid: is('android'),
    isMiniProgram: is('miniprogram'),
    isPassenger: is('passenger'),
  },
  methods: {
    selectCity: function(item) {
      this.triggerEvent('citySelect', {
        cityName: item.name,
        cityId: item.id,
        lat: item.lat,
        lng: item.lng,
      })
    },
    scroll: throttle(function(e) {
      if (!baseTop || this.intoView) {
        return
      }
      let list = []
      mpx.createSelectorQuery().in(this).selectAll('.didi-mall-city-list-block').boundingClientRect(res => {
        list = []
        for (let i = 0, len = res.length; i < len; i++) {
          if (-res[i].height + baseTop < res[i].top && res[i].top < windowHeight) {
            list.push(i)
          }
        }
        console.log(111)
        this.triggerEvent('scroll', { e, list })
      }).exec()
    }, 100),
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "index7dbcda14",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-scroll-view':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view.vue?component=true"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
